import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import customModal from "../customModal/customModal.vue";
import ts from "typescript";
import { _ } from "core-js";

export default {
    name: 'ManageRIskTaskModal',
    components: {
        customModal,
        Multiselect,
    },
    props: {
        riskId: {
            type: String,
            default: "",
        },
        riskRegId: {
            type: String,
            default: "",
        },
        tskId: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            idToken: store.getters.getIdToken,
            headerValues: {},
            studyId: "",
            roles: [],
            defaultdate: "",
            localTskId: this.tskId,
            values: {
                riskRegisterId: "",
                taskId: "",
                taskTitle: "",
                description: "",
                owner: [],
                ownerRoles: [],
                startDate: "",
                endDate: "",
                plannedEndDate: "",
                priority: "",
                status: "",
                comments: ""
            },
            roleList: [],
            userList: [],
            selectedemailrecipients: [],
            emailrecipients: [],
        };
    },
    async mounted() {
        this.studyId = store.getters.getStudyIs;
        this.defaultdate = localStorage.getItem("dateformat");
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        if (this.localTskId) {
           await this.setRoleList();
           await this.getRiskById();
            if (this.values.ownerRoles && this.values.ownerRoles.length > 0) {
                this.values.ownerRoles = 
                    this.roleList.filter(role => this.values.ownerRoles.includes(role.roleID));

                var roleIds = "";
                roleIds = this.values.ownerRoles.map(r => r.roleID).join(",");
                await this.getRoleBasedUserlist(roleIds);
            }
        }
        else{
             await this.setRoleList();
        }
        
        
    },
    methods: {
        closeTaskModal() {
            this.localTskId = "";
            this.values={};
            this.$emit('closeModal');
        },
        clear() {
            this.values ={};
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            return dateStr.split("T")[0]; 
        },
        async getRiskById() {
            try {
                var response = await axios.get(`${this.baseurl}/forms/riskregister/gettaskbyid?riskRegisterId=${this.riskRegId}&taskId=${this.localTskId}`, this.headerValues);
                this.riskDetails = response.data;
                if (response.data) {
                    this.values.taskId = response.data.taskID || "";
                    this.values.taskTitle = response.data.taskTitle || "";
                    this.values.description = response.data.description || "";
                    this.values.owner = response.data.owner || "";
                    this.values.startDate = this.formatDate(response.data.startDate || null);
                    this.values.endDate = this.formatDate(response.data.endDate || null);
                    this.values.plannedEndDate = this.formatDate(response.data.plannedEndDate || null);
                    this.values.plannedEndDate = response.data.plannedEndDate || "";
                    this.values.priority = response.data.priority || "";
                    this.values.status = response.data.status || "";
                    this.values.comments = response.data.comments || "";
                    this.values.ownerRoles = (response.data.ownerRoles || []).map(r => r.roleID);
                    this.values.owner = response.data.owner || []
                }
            }
            catch (error) {
                console.log("error getting risk...");
            }
        },
        async saveClicked() {
            this.values.riskRegisterId = this.riskRegId;
            try {
                this.values.startDate = this.values.startDate == "" ? null : this.values.startDate;
                this.values.endDate = this.values.endDate == "" ? null : this.values.endDate;
                this.values.plannedEndDate = this.values.plannedEndDate == "" ? null : this.values.plannedEndDate;
                
                var response = await axios.put(`${this.baseurl}/forms/riskregister/updatetask`, this.values, this.headerValues);
                alert("Task saved successfully")
                    this.$emit('closeModal');
                    this.$emit('refreshData');
            } catch (error) {
                console.error("Error saving task:", error);
            }
        },
        async setRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${this.baseurl}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    this.roleList = res.data;
                })
        },
        async onClear(){
            this.values.ownerRoles=[];
            this.userList=[]; 
            this.values.owner = [];
        },
        async onRecipientClear(){
            //  this.userList=[];
             this.values.owner = [];
        },
        async onSelectClosed(){
            var roleIds = "";
            if (this.values.ownerRoles && this.values.ownerRoles.length > 0) {
                roleIds = this.values.ownerRoles.map(r => r.roleID).join(",");
            }
            await this.getRoleBasedUserlist(roleIds); 
        },
        async getRoleBasedUserlist(roleIds) {
            this.userList=[];
            const idtoken = store.getters.getIdToken;
            if(this.values.ownerRoles && this.values.ownerRoles.length >0){
                axios
                .get(
                `${this.baseurl}/account-core/user/getusersbyrole?roleids=${roleIds}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                    this.userList = res.data;
                    this.values.owner =  this.values.owner.filter(email =>
                        this.userList.some(user => user.email === email)
                    );     
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                this.userList =[];
            }
        },
    }
}